// Translator notes: If-sentences, lesson 39 (engine/src/conditionals.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  conditionalImagined: {
    args: [],
    fi: () =>
      'Kuviteltu ehto (oppitunti 39): lo ja preesensin subjunktiivi, päälauseessa futuurin subjunktiivi (”Lo zaldrīzes ikson, sepār sōvīlun” = jos olisin lohikäärme, niin lentäisin).',
    en: () =>
      'An imagined condition (lesson 39): lo with the present subjunctive, and the future subjunctive in the main clause (“Lo zaldrīzes ikson, sepār sōvīlun” = if I were a dragon, then I would fly).',
  },
  conditionalPast: {
    args: [],
    fi: () => 'Kuviteltu ehto menneisyydessä (oppitunti 39): perfektin subjunktiivi kummassakin lauseessa (”jos hän olisi tullut, olisimme nähneet hänet”).',
    en: () => 'An imagined condition in the past (lesson 39): the perfect subjunctive in both clauses (“if he had come, we would have seen him”).',
  },
  conditionalOpen: {
    args: [],
    fi: () =>
      'Ehtolauseessa on lo ja subjunktiivi, kuten sarjan repliikeissä yleensä. Jos pidät ehtoa totena, oppitunti 39 käyttää indikatiivia – se on ensimmäisenä vaihtoehtona.',
    en: () =>
      'The if-clause has lo and the subjunctive, as the show’s lines mostly do. If you take the condition as real, lesson 39 uses the indicative – it is the first alternative.',
  },
  conditionalThen: {
    args: [],
    fi: () => '”Niin” tai ”sitten” jos-lauseen jälkeen on sepār, kuten oppitunnilla 39.',
    en: () => '“Niin” or “sitten” (then) after a jos-clause is sepār, as in lesson 39.',
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
